<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Leads</h4>
            <a style="float:right" href="https://storeapi.opolen.com.br/Api/lead/ExcelExportLeads?token=ott"
              class="btn btn-sm btn-success btn-wd"><span class="ti-download"></span> Download Excel</a>
            <p class="category" style="float:left">Lista de Leads que começaram cadastro mas ñ concluíram o teste grátis
            </p>
            <div class="col-sm-4">
              <input class="form-control" type="text" placeholder="Ari e Sergio, pesquise aqui! de Enter"
                (change)="filterByNameEmail()" name="byname" [(ngModel)]="storeFilter.byname" required
                #byname="ngModel">
            </div>
          </div>
          <div class="card-content table-full-width">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th></th>
                  <th>#</th>
                  <th>Email</th>
                  <th>Loja</th>
                  <th>Domínio</th>
                  <th>Data</th>
                  <th class="text-right">Ações</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let store of leads; let i = index" [attr.data-index]="i" [hidden]="!store.filterShow">
                  <td>
                    <div (click)="showDetails(store)"><i class="fa fa-search"></i></div>
                  </td>
                  <td>{{ i+1 }}</td>
                  <td>{{store.updateDate | date:'dd/MM/yy' : 'UTC 0'}}</td>
                  <td>{{store.email}}</td>
                  <td>{{store.name}}</td>
                  <td><a href="{{store.domain}}" target="_blank" title="{{store.domain }}">{{store.domain}}</a></td>

                  <td class="td-actions text-right">
                    <button (click)="deleteLead(store.email)" class="btn btn-sm">Deletar</button>&nbsp;
                    <!-- <button class="btn btn-sm">Analytics</button> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>